var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormResponsePageTemplate',{attrs:{"intro":_vm.intro,"text":_vm.text,"background-color":"#4a31c0","icon-color":"white","text-color":"white","next":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }